module.exports = __webpack_public_path__ + "img/pop.048b9c36.gif";